module.exports = __webpack_public_path__ + "static/wolt-f76170d676c23b6423bfb1757a944ff8.png";